import React from 'react'
import careconnect from "../assets/project-assets/careconnect.png"
import sunlightgardens from "../assets/project-assets/sunlight-gardens.png"
import blog from "../assets/project-assets/blog.png"
import ll from "../assets/project-assets/ll.png"
import bakery from "../assets/project-assets/bakery.png"
import torontoJsBl from '../assets/project-assets/torontojs-blog.png'
import photog from "../assets/project-assets/photog.png"
import moodboard from "../assets/project-assets/moodboard.png"
import torontoJsVol from '../assets/project-assets/torontoJSVol.png'
import treesForLife from '../assets/project-assets/treesForLife.png'
import meowApi from '../assets/project-assets/meowApi.png'
// import cohereGen from '../assets/project-assets/cohereGen.png'

const Portfolio = () => {

    const portfolios = [
           {
            id: 1,
            title: "Care Connect Demo",
            src: careconnect,
            demoLink: 'https://careconnect-1q2d.onrender.com'
        },
           {
            id: 2,
            title: "Sunlight Gardens Demo",
            src: sunlightgardens,
            demoLink: 'https://sunlight-gardens.netlify.app/'
        },{
            id: 3,
            title: "Blog Demo",
            src: blog,
            demoLink: 'https://v1blog.netlify.app/'
        },
         {
            id: 4,
            title: "Lunes Landscaping Demo",
            src: ll,
            demoLink: 'https://lune-s-landscape.webflow.io/'
        },
        {
            id: 5,
            title: "Lune's Bakery Demo",
            src: bakery,
            demoLink: 'https://lunesbakery.netlify.app/'
        },
        {
            id: 6,
            title: "TorontoJS Blog Demo",
            src: torontoJsBl,
            codeLink: 'https://github.com/torontojs/blog',
            demoLink: 'https://blog.torontojs.com/'
        },
         {
            id: 7,
            title: "PhotosByLune Demo",
            src: photog,
            demoLink: 'https://photosbylune.netlify.app'
        },
         {
            id: 8,
            title: "Moodboard Demo",
            src: moodboard,
            demoLink: 'https://moodboard2026.netlify.app/'
        },
        {
            id: 9,
            src: torontoJsVol,
            title: "TorontoJS Volunteer Demo",
            codeLink: 'https://github.com/torontojs/torontojs.com',
            demoLink: 'https://torontojs.com/volunteers'
        },
        {
            id: 10,
            title: "TreesForLife Demo",
            src: treesForLife,
            demoLink: 'https://treesareneededforlife.netlify.app/'
        },
        {
            id: 11,
            title: "Meow Api Demo",
            src: meowApi,
            demoLink: 'https://meow-api-i9z4.onrender.com/'
        }
         // fix this ? maybe just need to fork from old github
        // {
        //     id: 6,
        //     src: cohereGen,
        //     demoLink: 'https://cohere-appppp.netlify.app/'
        // },
    ]

  return (
    <div name='portfolio' className='bg-gradient-to-b from-orange-500 via-orange to-pink-300 w-full h-full text-black font-bold'> 
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <div classname='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-green-500'>Portfolio</p>
            </div>

            <div className='grid py-6 sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0 mb-20'>
                
            {
                portfolios.map(({ id, src, title, codeLink, demoLink }) => (
                    <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
                        <img
                            src={src}
                            alt="projects"
                            className="rounded-md w-22 h-22 duration-200 hover:scale-105"
                        />
                        <div className="flex items-center justify-center">
                            {demoLink && (
                                <button
                                    onClick={() => window.open(demoLink, "_blank")}
                                    rel="noreferrer"
                                    className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105"
                                >
                                    {title}
                                </button>
                            )}
                            {/* <button
                                onClick={() => window.open(codeLink, "_blank")}
                                rel="noreferrer"
                                className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105"
                            >
                                Code
                            </button> */}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
  )
}

export default Portfolio
